import CreditCardIcon from "components/Icons/CreditCardIcon";
import UserIcon from "components/Icons/UserIcon";
import WindIcon from "components/Icons/WindIcon";
import useCreateDriver from "hooks/drivers/useCreateDriver";
import DriverInfoStepper from "./components/DriverInfoStepper";
import FleetInfoStepper from "./components/FleetInfoStepper";
import WalletInfoStepper from "./components/WalletInfoStepper";

export default function CreateDriver() {
  const {
    loading,
    fleetModels,
    stepper,
    handleBackStepper,
    onDriverInfoSubmit,
    onFleetInfoSubmit,
    onWalletSubmit,
    handleStepper1,
    handleStepper2,
    handleStepper3,
    handleUploadDriverImage,
    handleUploadDriverLicenseImage,
    handleUploadInsuranceSubscriptionImage,
    handleUploadEmploymentAgreementImage,
    handleUploadMaheberSupportImage,
    handleUploadDriverIdImage,
    handleUploadOwnerIdImage,
    handleUploadBoloImage,
    handleUploadBusinessLicenseImage,
    handleUploadFleetImage,
    handleUploadLicenseImage,
  } = useCreateDriver();

  return (
    <div
      className="w-full bg-white rounded-lg p-6"
      style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
    >
      <div className="w-full pt-5 pb-5">
        <div className="w-full">
          <h1 className="p-5 font-light text-lg text-center">Add New Driver</h1>
          {/* Stepper icons */}
          <div className="w-full">
            <div className="w-full relative h-1 top-7 overflow-clip rounded-md">
              <div
                className={`duration-500 transition-all ${
                  stepper === 1 ? "w-1/6" : stepper === 2 ? "w-3/6" : "w-5/6"
                } bg-black h-full rounded-md`}
              ></div>
            </div>
            <div className="relative w-full flex items-center">
              <div className="w-1/3 flex items-center justify-center">
                <button
                  onClick={handleStepper1}
                  className="relative h-14 w-14 border-[3px] bg-black border-black rounded-full flex items-center justify-center text-white text-2xl"
                >
                  <UserIcon />
                </button>
              </div>
              <div className="w-1/3 flex items-center justify-center">
                <button
                  onClick={handleStepper2}
                  className={`relative h-14 w-14 border-[3px] ${
                    stepper >= 2
                      ? "bg-black text-white border-black"
                      : "bg-white text-black-200 border-black"
                  } rounded-full flex items-center justify-center text-2xl`}
                >
                  <WindIcon />
                </button>
              </div>
              <div className="w-1/3 flex items-center justify-center">
                <button
                  onClick={handleStepper3}
                  className={`relative h-14 w-14 border-[3px] ${
                    stepper >= 3
                      ? "bg-black text-white border-black"
                      : "bg-white text-black-200 border-black"
                  } rounded-full flex items-center justify-center text-2xl`}
                >
                  <CreditCardIcon />
                </button>
              </div>
            </div>
          </div>
          <p className="text-center mt-2 text-sm font-normal">
            City Information
          </p>
        </div>
        <div className="w-full py-8 px-5">
          {/* stepper 1 */}
          <DriverInfoStepper
            handleBackStepper={handleBackStepper}
            stepper={stepper}
            onDriverInfoSubmit={onDriverInfoSubmit}
            handleUploadDriverImage={handleUploadDriverImage}
            handleUploadDriverLicenseImage={handleUploadDriverLicenseImage}
            handleUploadInsuranceSubscriptionImage={
              handleUploadInsuranceSubscriptionImage
            }
            handleUploadEmploymentAgreementImage={
              handleUploadEmploymentAgreementImage
            }
            handleUploadMaheberSupportImage={handleUploadMaheberSupportImage}
            handleUploadDriverIdImage={handleUploadDriverIdImage}
            handleUploadOwnerIdImage={handleUploadOwnerIdImage}
            handleUploadBoloImage={handleUploadBoloImage}
            handleUploadBusinessLicenseImage={handleUploadBusinessLicenseImage}
          />

          {/* stepper 2 */}
          <FleetInfoStepper
            fleetModels={fleetModels}
            handleBackStepper={handleBackStepper}
            stepper={stepper}
            onFleetInfoSubmit={onFleetInfoSubmit}
            handleUploadFleetImage={handleUploadFleetImage}
            handleUploadLicenseImage={handleUploadLicenseImage}
          />

          {/* stepper 3 */}
          <WalletInfoStepper
            banks={{
              loading: false,
              data: [
                { name: "Abay Bank" },
                { name: "Enat Bank" },
                { name: "Hijra Bank" },
                { name: "Nib International Bank" },
                { name: "Oromia International Bank" },
                { name: "Sinqee Bank" },
                { name: "United Bank" },
                { name: "Wegagen Bank" },
                { name: "ZamZam Bank" },
                { name: "Zemen Bank" },
                { name: "Global Bank" },
                { name: "Amhara Bank" },
                { name: "Ahadu Bank" },
                { name: "Awash International Bank" },
                { name: "Addis International Bank" },
                { name: "Bank of Abyssinia" },
                { name: "Berhan International Bank" },
                { name: "Bunna Bank" },
                { name: "Commercial Bank Of Ethiopia" },
                { name: "Cooperative Bank of Oromia" },
                { name: "Lion International Bank" },
                { name: "Dashen Bank" },
                { name: "Rays MFI" },
                { name: "Somali Micro Finance" },
                { name: "KAAFI MFI" },
                { name: "telebirr - wallet" },
                { name: "CBE Birr" },
                { name: "Sahal mfi" },
                { name: "Tsehay bank" },
                { name: "Yaya wallet" },
              ],
            }}
            handleBackStepper={handleBackStepper}
            stepper={stepper}
            onWalletInfoSubmit={onWalletSubmit}
            loading={loading}
          />
        </div>
      </div>
    </div>
  );
}
